import React from 'react'
import { PageHeader, FlexContainer, Tile } from '@reapit/elements'

const UpdateSettingsBlock: React.FC = () => {
  return (
    <>
      <PageHeader
        avatar={{
          src: 'error.png',
          type: 'image',
        }}
        hasMaxWidth
        pageTitle={{
          children: 'Your account settings need a tweak...',
          hasBoldText: true,
        }}
        pageSubtitle={{
          children: 'Please head over to the "Account Settings" area of prospector pro.',
        }}
      />
      <FlexContainer hasMaxWidth isFlexColumn>
        <Tile>
          <p className="el-mb6" style={{ fontSize: '20px' }}>
            Notice: It appears you have not yet set up your phone numbers for the desktop app.
          </p>

          <p className="el-mb6">
            To do this, please log in to Prospector Pro at{' '}
            <a href="https://app.prospectorpro.co.uk" target="_blank" rel="noreferrer">
              https://app.prospectorpro.co.uk
            </a>
            . Then, navigate to Account &raquo; Account Settings and enter the following:
          </p>

          <p className="el-mb2">
            - <span style={{ fontWeight: 'bold' }}>Native app - Display number</span>
          </p>
          <p className="el-mb6">
            - <span style={{ fontWeight: 'bold' }}>Native app - Routing number</span>
          </p>

          <p className="el-mb6">
            After entering the numbers, click <span style={{ fontWeight: 'bold' }}>Save</span> and try again.
          </p>

          <p className="el-mb6">Please ensure that you enter these numbers carefully:</p>

          <p className="el-mb2">
            <span style={{ fontWeight: 'bold' }}>The Routing Number</span> is the number we will call you on.
          </p>
          <p className="el-mb10">
            <span style={{ fontWeight: 'bold' }}>The Display Number</span> is what your customers will see when you
            call.
          </p>
          <p className="el-mb6">
            <span style={{ fontWeight: 'bold' }}>Need help?</span>
            <br /> Contact our team on{' '}
            <a href="mailto:support@prospectorpro.co.uk" target="_blank" rel="noreferrer">
              support@prospectorpro.co.uk
            </a>
            .
          </p>
        </Tile>
      </FlexContainer>
    </>
  )
}

export default UpdateSettingsBlock
